const CompareIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width='18'
      height='14'
      viewBox='0 0 18 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.4107 0.656673C13.0853 0.982114 13.0853 1.50975 13.4107 1.83519L14.4881 2.9126H9.83329C7.99238 2.9126 6.49996 4.40498 6.49996 6.24593V7.07926C6.49996 7.53951 6.87306 7.9126 7.33329 7.9126C7.79354 7.9126 8.16663 7.53951 8.16663 7.07926V6.24593C8.16663 5.32546 8.91279 4.57926 9.83329 4.57926H14.4881L13.4107 5.65668C13.0853 5.9821 13.0853 6.50976 13.4107 6.83518C13.7361 7.1606 14.2638 7.1606 14.5892 6.83518L17.0892 4.33519C17.4146 4.00975 17.4146 3.48211 17.0892 3.15667L14.5892 0.656673C14.2638 0.331239 13.7361 0.331239 13.4107 0.656673ZM10.6666 6.24593C10.2064 6.24593 9.83329 6.61901 9.83329 7.07926V7.9126C9.83329 8.8331 9.08713 9.57926 8.16663 9.57926H3.5118L4.58922 8.50185C4.91465 8.17643 4.91465 7.64876 4.58922 7.32335C4.26378 6.99793 3.73614 6.99793 3.4107 7.32335L0.910701 9.82335C0.585268 10.1488 0.585268 10.6764 0.910701 11.0018L3.4107 13.5018C3.73614 13.8273 4.26378 13.8273 4.58922 13.5018C4.91465 13.1764 4.91465 12.6488 4.58922 12.3233L3.5118 11.2459H8.16663C10.0075 11.2459 11.5 9.75352 11.5 7.9126V7.07926C11.5 6.61901 11.1269 6.24593 10.6666 6.24593Z'
        fill='#003DD4'
      />
    </svg>
  )
}

export default CompareIcon
